// "Disables" a panel by adding a blank div just inside the element, before its first child and
// applying grayed out styling.
module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            disabled: '=olyDisablePanel',
        },
        link(scope, element) {
            scope.$watch('disabled', (isDisabled) => {
                element.toggleClass('u-disabledPanel', isDisabled);
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/disablepanel/disablepanel.directive.js